import React from "react";
import { CircleCheckIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { practicalCards } from "../../data/content";
const spans = ["lg:col-span-2", "lg:col-span-2", "lg:col-span-2", "lg:col-span-3", "lg:col-span-3"];
export function PracticalBenefits() {
  return <section className="w-full bg-green-light px-5 py-14 md:py-20" data-id="element-177" data-mp="xrlevec3fib8">
      <div className="mx-auto max-w-5xl" data-id="element-178" data-mp="1vekcbram0ua6">
        <SectionHeading title={<>Less planning.<br data-id="element-180" data-mp="1vgn52j35d1il" /><span className="text-green" data-id="element-181" data-mp="1vgd8udridy4g">More ready-to-coach training.</span></>} data-id="element-179" data-mp="1vdisoyfj2zgu" />

        <ul className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-6" data-id="element-182" data-mp="1qg923fgekhrf">
          {practicalCards.map((card, i) => <li key={card.question} className={`flex h-full flex-col rounded-xl bg-white p-5 shadow-[0_8px_20px_-14px_rgba(28,47,79,0.4)] ${spans[i]}`} data-id="element-183" data-mp="1lmecjve498kf" data-mpi={i}>
              <p className="font-display text-sm font-extrabold uppercase leading-snug text-navy" data-id="element-184" data-mp="2e5tpcajla16i">{card.question}</p>
              <p className="mt-auto flex items-center gap-2 pt-4 text-sm font-bold text-green" data-id="element-185" data-mp="29d0jtkgaqotd">
                <CircleCheckIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-186" data-mp="20o027yat4j1o" />
                {card.answer}
              </p>
            </li>)}
        </ul>

      </div>
    </section>;
}